<template>
    <a-layout id="setting" class="page_layout">
        <a-layout-content class="page_content setting_content single">
            <a-page-header title="企业基础信息配置" :backIcon="false" />
            <a-form-model
                layout="horizontal"
                ref="setForm"
                :model="detailData"
                :rules="rules"
                :labelCol="{ span: 4 }"
                :wrapperCol="{ span: 14 }"
            >
                <a-form-model-item label="企业ID" prop="corpId">
                    <a-input v-model="detailData.corpId" placeholder="企业ID" />
                </a-form-model-item>
                <a-form-model-item label="外部联系人密钥" prop="externalContactSecret">
                    <a-input
                        v-model="detailData.externalContactSecret"
                        placeholder="登录企业微信管理后台 - 客户联系人 - API - Secret"
                    />
                </a-form-model-item>
            </a-form-model>
            <a-divider />
            <a-form-model>
                <a-form-model-item>
                    <a-button type="primary" @click="toSave">保存</a-button>
                </a-form-model-item>
            </a-form-model>
            <a-divider orientation="left">配置步骤</a-divider>
            <a-steps v-model="current" direction="vertical" @change="stepChange">
                <a-step :status="current === 0 ? 'process' : 'wait'">
                    <p slot="title">
                        访问企业微信官网
                        <a href="https://work.weixin.qq.com" target="_blank">
                            https://work.weixin.qq.com
                        </a>
                        ，点击右上角登录
                    </p>
                    <a
                        href="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-01.png"
                        target="_blank"
                        slot="description"
                        v-if="current === 0"
                    >
                        <a-tooltip title="点击查看大图">
                            <img
                                style="width:500px;"
                                src="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-01.png"
                            />
                        </a-tooltip>
                    </a>
                </a-step>
                <a-step :status="current === 1 ? 'process' : 'wait'">
                    <p slot="title">企业微信管理员扫码</p>
                    <a
                        href="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-02.png"
                        target="_blank"
                        slot="description"
                        v-if="current === 1"
                    >
                        <a-tooltip title="点击查看大图">
                            <img
                                style="width:500px;"
                                src="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-02.png"
                            />
                        </a-tooltip>
                    </a>
                </a-step>
                <a-step :status="current === 2 ? 'process' : 'wait'">
                    <p slot="title">进入企业微信后台，选择客户联系栏目，点击 API 下拉按钮</p>
                    <a
                        href="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-03.png"
                        target="_blank"
                        slot="description"
                        v-if="current === 2"
                    >
                        <a-tooltip title="点击查看大图">
                            <img
                                style="width:500px;"
                                src="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-03.png"
                            />
                        </a-tooltip>
                    </a>
                </a-step>
                <a-step :status="current === 3 ? 'process' : 'wait'">
                    <p slot="title">复制 secret，进入机汇管家后台粘贴</p>
                    <a
                        href="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-04.png"
                        target="_blank"
                        slot="description"
                        v-if="current === 3"
                    >
                        <a-tooltip title="点击查看大图">
                            <img
                                style="width:500px;"
                                src="https://cdn.jihuinet.com/jihui_work_keeper/assets/contact-secret-04.png"
                            />
                        </a-tooltip>
                    </a>
                </a-step>
            </a-steps>
        </a-layout-content>
    </a-layout>
</template>

<script>
import api from '@/apis';
export default {
    data() {
        return {
            current: 0,
            detailData: {
                corpId: '',
                externalContactSecret: ''
            },
            rules: {
                corpId: [{ required: true, message: '企业ID不能为空' }],
                externalContactSecret: [{ required: true, message: '外部联系人密钥不能为空' }]
            }
        };
    },
    mounted() {
        this.detailData.corpId = window.sessionStorage.getItem('corpid');
        this.init();
    },
    methods: {
        async init() {
            try {
                const res = await api.getSetting();
                if (res.code !== 0) return;
                this.detailData.externalContactSecret = res.externalContactSecret;
            } catch (err) {
                console.log(err);
            }
        },
        async toSave() {
            try {
                this.$refs.setForm.validate(async (valid) => {
                    if (valid) {
                        const res = await api.postSetting(this.detailData);
                        if (res.code !== 0) return;
                        this.$message.success('保存成功');
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        stepChange(e) {
            this.current = e;
        }
    }
};
</script>

<style scoped>
#setting .setting_content {
    overflow-x: hidden;
    overflow-y: scroll;
}
</style>